import { __extends } from "tslib";
import cx from 'classnames';
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { findDOMNode } from 'react-dom';
import { VelocityTransitionGroup } from 'velocity-react';
import styles from './Annotation.module.css';
import { CheckSmallIcon } from './icons';
// TODO calculate this from ANNOTATION_SIZE?
var pulseAnimation = {
    animation: {
        width: [200, 100],
        height: [200, 100],
        opacity: [0, 0.6],
    },
};
var annotationSource = {
    beginDrag: function (props, monitor, component) {
        var comp = findDOMNode(component).getBoundingClientRect();
        return {
            id: props.id,
            commentUUID: props.commentUUID,
            screenArea: props.screenArea,
            isDone: props.isDone,
            isSaved: props.isSaved,
            isHiddenForDrag: true,
            isDragging: true,
            initialPosition: {
                top: comp.top,
                left: comp.left,
            },
        };
    },
};
function collect(connect, monitor) {
    return {
        isHiddenForDrag: monitor.isDragging(),
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
    };
}
var Annotation = /** @class */ (function (_super) {
    __extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Annotation.prototype.componentDidMount = function () {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage());
    };
    Annotation.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, position = _b.position, isMoveable = _b.isMoveable, isDragging = _b.isDragging, isHiddenForDrag = _b.isHiddenForDrag, isHighlighted = _b.isHighlighted, isDehighlighted = _b.isDehighlighted, isPulsing = _b.isPulsing, isDone = _b.isDone, isSaved = _b.isSaved, connectDragSource = _b.connectDragSource, onClick = _b.onClick, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave;
        var annotationClass = cx(styles.annotation, (_a = {},
            _a[styles.hiddenForDrag] = isHiddenForDrag,
            _a[styles.draggingDone] = isDragging && isDone,
            _a[styles.dragging] = isDragging,
            _a[styles.moveable] = isMoveable,
            _a[styles.highlight] = isHighlighted,
            _a[styles.highlightDone] = isHighlighted && isDone,
            _a[styles.dehighlight] = isDehighlighted,
            _a[styles.done] = !isDehighlighted && !isDragging && !isHighlighted && isDone,
            _a[styles.normal] = !isDehighlighted && !isDone,
            _a[styles.new] = !isSaved,
            _a));
        var annotation = (React.createElement("div", { className: annotationClass, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: position },
            React.createElement(VelocityTransitionGroup, { enter: {
                    animation: { scale: [1, 0] },
                    style: { scale: 0 },
                    easing: [0, 0.89, 0.44, 1],
                    delay: 25,
                    duration: 300,
                }, runOnMount: true }, isDone ? (React.createElement("span", { className: styles.annotationNumber },
                React.createElement("span", { className: styles.completedIcon },
                    React.createElement(CheckSmallIcon, null)))) : undefined),
            React.createElement(VelocityTransitionGroup, { leave: {
                    animation: { scale: [0, 1] },
                    easing: [0, 0.89, 0.44, 1],
                    delay: 25,
                    duration: 300,
                }, runOnMount: true }, !isDone ? React.createElement("span", { className: styles.completed }, id) : undefined),
            React.createElement(VelocityTransitionGroup, { leave: pulseAnimation, runOnMount: true }, isPulsing ? React.createElement("div", { className: styles.notification }) : undefined)));
        if (isMoveable) {
            return connectDragSource(annotation);
        }
        return annotation;
    };
    Annotation.propTypes = {
        // eslint-disable-next-line react/no-unused-prop-types
        commentUUID: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        position: PropTypes.shape({
            top: PropTypes.number.isRequired,
            left: PropTypes.number.isRequired,
        }).isRequired,
        isMoveable: PropTypes.bool,
        isDragging: PropTypes.bool,
        isHiddenForDrag: PropTypes.bool,
        isHighlighted: PropTypes.bool,
        isDehighlighted: PropTypes.bool,
        isPulsing: PropTypes.bool,
        isDone: PropTypes.bool,
        isSaved: PropTypes.bool,
        connectDragSource: PropTypes.func.isRequired,
        connectDragPreview: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        onMouseEnter: PropTypes.func.isRequired,
        onMouseLeave: PropTypes.func.isRequired,
    };
    Annotation.defaultProps = {
        connectDragSource: noop,
        connectDragPreview: noop,
        onClick: noop,
        onMouseEnter: noop,
        onMouseLeave: noop,
    };
    return Annotation;
}(React.Component));
export default dragSource('annotation', annotationSource, collect)(Annotation);
